import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaPhoneAlt, FaAt } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";

import { OTP } from "services/action";

import { Page, Input } from "ui/components";
import forget from "../../../assets/forget.png";

const ForgetPasswordScreen = () => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state.Form);

  const [username, setUsername] = React.useState("");
  const [phone, setPhone] = React.useState("");

  const $handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      username: username,
      phone: phone,
    };
    const req = await Dispatch(OTP.$send(payload));

    if (req?.message === "success") {
      History.push({
        pathname: "/verify",
        state: {
          phone: phone,
          phone_otp: req?.data?.replace("62", "0"),
          type: "reset",
        },
      });
    }
  };

  return (
    <Page className="bg-container-image ">
      <div className="mt-3 mb-3 d-flex align-items-center justify-content-center">
        <img src={forget} alt="" height={200} />
      </div>

      <div>
        <div style={{ fontSize: 20, fontWeight: 700, textAlign: "left" }}>
          Lupa Kata Sandi?
        </div>
        <div className="mt-2 mb-2" style={{ textAlign: "left" }}>
          Masukkan email dan nomor handphone anda yang terdaftar untuk membantu
          kami mengetahui siapa anda.
        </div>

        <form onSubmit={$handleSubmit}>
          <div className="form-group mb-3 ">
            <Input
              icon={<FaAt />}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              type="text"
              placeholder="masukkan username anda"
              error={StateForm?.errors?.username}
              lg
            />
          </div>
          <div className="form-group">
            <Input
              icon={<FaPhoneAlt />}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              type="number"
              placeholder="masukkan nomor handphone anda"
              error={StateForm?.errors?.phone}
              lg
            />
          </div>

          <Button
            type="submit"
            variant="primary"
            className="w-100 mt-3 p-2 border border-primary fs-7"
            disabled={StateForm?.loading}
          >
            {!StateForm?.loading ? (
              "Selanjutnya"
            ) : (
              <div className="spinner-border" role="status"></div>
            )}
          </Button>
        </form>

        <div className="page-pretitle text-secondary mt-2 text-center cursor-pointer">
          Kembali ke{" "}
          <span
            className="text-primary"
            onClick={() => History.push("/signin")}
          >
            Halaman Masuk
          </span>
        </div>
      </div>
    </Page>
  );
};

export default ForgetPasswordScreen;
